// extracted by mini-css-extract-plugin
export default {"wrap":"CG-z","subtitle":"DG-z","contentWrap":"EG-z","imgWrap":"FG-z","heading":"GG-z","copy":"HG-z"};